import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || (window.location.origin.includes('localhost:3000') ? 'http://localhost:3001' : '');

function TokenManagement() {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newTokenName, setNewTokenName] = useState('');
  const [generatedToken, setGeneratedToken] = useState(null);
  const [error, setError] = useState(null);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    loadTokens();
  }, []);

  const loadTokens = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/tokens`);
      setTokens(response.data);
      setLoading(false);
    } catch (err) {
      setError('Erreur lors du chargement des tokens');
      setLoading(false);
    }
  };

  const createToken = async (e) => {
    e.preventDefault();
    if (!newTokenName) return;

    try {
      setCreating(true);
      setError(null);
      const response = await axios.post(`${API_URL}/api/tokens`, { name: newTokenName });
      setGeneratedToken(response.data.token);
      setNewTokenName('');
      loadTokens();
      setCreating(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la création du token');
      setCreating(false);
    }
  };

  const deleteToken = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce token ?')) return;

    try {
      await axios.delete(`${API_URL}/api/tokens/${id}`);
      loadTokens();
    } catch (err) {
      setError('Erreur lors de la suppression du token');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('fr-FR');
  };

  return (
    <div className="token-management">
      <div className="section-header">
        <h2>Jetons d'API</h2>
        <p>Utilisez ces jetons pour automatiser l'upload de vos packs via CI/CD (GitHub Actions, etc.)</p>
      </div>

      <div className="token-info-alert">
        <div className="alert-icon">ℹ️</div>
        <div className="alert-content">
          Pour utiliser un jeton, envoyez-le dans le header <code>Authorization: Bearer VOTRE_TOKEN</code>.
          Consultez la <a href={`${API_URL}/api-docs`} target="_blank" rel="noopener noreferrer">Documentation Swagger</a> pour plus de détails.
        </div>
      </div>

      {generatedToken && (
        <div className="generated-token-display">
          <h3>Nouveau jeton créé !</h3>
          <p className="warning-text">⚠️ Copiez ce jeton maintenant, vous ne pourrez plus le voir ensuite.</p>
          <div className="token-value-container">
            <code className="token-value">{generatedToken}</code>
            <button className="btn btn-secondary" onClick={() => {
              navigator.clipboard.writeText(generatedToken);
              alert('Copié dans le presse-papier !');
            }}>Copier</button>
          </div>
          <button className="btn btn-primary" onClick={() => setGeneratedToken(null)} style={{marginTop: '10px'}}>Terminé</button>
        </div>
      )}

      <div className="create-token-form">
        <form onSubmit={createToken}>
          <div className="form-group-inline">
            <input
              type="text"
              placeholder="Nom du jeton (ex: GitHub Actions)"
              value={newTokenName}
              onChange={(e) => setNewTokenName(e.target.value)}
              required
            />
            <button type="submit" className="btn btn-primary" disabled={creating}>
              {creating ? 'Création...' : 'Créer un jeton'}
            </button>
          </div>
        </form>
      </div>

      {error && <div className="error">{error}</div>}

      {loading ? (
        <div className="loading">Chargement des jetons...</div>
      ) : tokens.length === 0 ? (
        <div className="empty-state">
          <p>Aucun jeton d'API actif.</p>
        </div>
      ) : (
        <table className="user-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Créé le</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tokens.map(token => (
              <tr key={token.id}>
                <td><strong>{token.name}</strong></td>
                <td>{formatDate(token.createdAt)}</td>
                <td>
                  <button className="btn btn-danger btn-sm" onClick={() => deleteToken(token.id)}>
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TokenManagement;
